@if (badge(); as badge) {
  <glxy-badge [color]="badge.color">
    {{ badge.labelKey | translate: { time: (badge.seconds | glxyDuration: durationOptions) } }}
  </glxy-badge>
} @else {
  <glxy-blank-value></glxy-blank-value>
}
